module.exports = __webpack_public_path__ + "media/10.e2b35bdc.mp3";